import Icon from '@dtvgo/icon';
import './CardCreateProfile.scss';
import { jsx, jsxs } from 'react/jsx-runtime';

function CardCreateProfile(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    _ref$isInputNotEmpty = _ref.isInputNotEmpty,
    isInputNotEmpty = _ref$isInputNotEmpty === void 0 ? '' : _ref$isInputNotEmpty,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx("div", {
    className: "dtv-common-c-card-create-profile ".concat(className),
    children: /*#__PURE__*/jsxs("div", {
      className: "dtv-common-c-card-create-profile__tag dtv-common-c-card-create-profile__tag--".concat(color),
      children: [/*#__PURE__*/jsx(Icon, {
        className: "dtv-common-c-card-create-user-icon ".concat(isInputNotEmpty.length > 0 ? 'display-none' : '', " "),
        name: "user"
      }), isInputNotEmpty.length > 0 ? /*#__PURE__*/jsx("div", {
        className: "dtv-common-c-card-create-profile__name",
        children: isInputNotEmpty
      }) : '']
    })
  });
}

export { CardCreateProfile as default };
//# sourceMappingURL=CardCreateProfile.js.map
